import { ActionType, Action, directionState } from "../actions/types"

const initialDirectionState: directionState = {
  direction: {}
}

const directionReducer = (
  state: directionState = initialDirectionState,
  action: Action
) => {
  switch (action.type) {
    case ActionType.SET_DIRECTION:
      return {
        ...state,
        direction: action.payload
      }
    default:
      return state
  }
}

export default directionReducer
